<template>
  <div class="accordion">
    <div :class="['accordion__header', canExpand ? 'accordion--expandable' : '']" v-on:click="toggleExpanded">
      <div class="accordion__header--text">
        <slot name="header">
          <h3 :class="['title', name ? 'title-shrink' : '']">{{title}}</h3>
          <h3 class="name">{{name}}</h3>
        </slot>
      </div>
      <span :class="['icon', expanded && canExpand ? 'icon-expanded' : '']">
        <svg v-if="!loading" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 8.25C6.68359 8.25 6.40234 8.14453 6.19141 7.93359L0.566406 2.30859C0.109375 1.88672 0.109375 1.14844 0.566406 0.726562C0.988281 0.269531 1.72656 0.269531 2.14844 0.726562L7 5.54297L11.8164 0.726562C12.2383 0.269531 12.9766 0.269531 13.3984 0.726562C13.8555 1.14844 13.8555 1.88672 13.3984 2.30859L7.77344 7.93359C7.5625 8.14453 7.28125 8.25 7 8.25Z" fill="#262626"/>
        </svg>
        <loader v-if="loading"></loader>
      </span>
    </div>
    <VueSlideToggle :open="expanded" tag="section" :duration="300">
      <div class="accordion--body">
        <slot name="body"></slot>
      </div>
    </VueSlideToggle>
  </div>
</template>

<style scoped>
.accordion {
  border: 1px solid #ebebeb;
  border-radius: 4px;
  margin-bottom: 32px;
}

.accordion--body {
  padding: 0 24px 16px;
}

.accordion__header {
  padding: 16px 24px;
  cursor: not-allowed;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  background: #ffffff8a;
  z-index: 9;
  backdrop-filter: blur(10px);
}

.accordion--expandable {
  cursor: pointer;
}
.icon svg{
  fill: #fff;
}
.icon {
  font-size: 21px;
  margin-left: auto;
  align-self: center;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.icon-expanded{
  transform: rotate(180deg);
}

.title{
  transition: all 0.3s ease;
}

.title-shrink{
  font-size: 14px;
  margin: 0;
  color: #5a5a5a;
}

.name{
  line-height: 1.5;
  margin: 0;
  color: #262626;
}
</style>

<script>
import AccordionEventBus from './AccordionEventBus'
import {VueSlideToggle} from 'vue-slide-toggle'

export default {
  components: {
    VueSlideToggle
  },
  props: {
    isExpandable: {
      type: Boolean,
      default: true
    },
    initiallyExpanded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    expanded: false
  }),
  beforeMount() {
    if (this.isExpandable) {
      this.expanded = this.initiallyExpanded
    }
  },
  mounted() {
    AccordionEventBus.$on(`set-accordion`, (args) => {
      if(args.key === this.$vnode.key){
        this.expanded = args.expanded
      }
    })
  },
  beforeDestroy() {
    // removing eventBus listener
    AccordionEventBus.$off(`set-accordion`)
  },
  methods: {
    toggleExpanded() {
      if (this.canExpand) {
        this.expanded = !this.expanded
      }
    }
  },
  computed: {
    canExpand() {
      return this.isExpandable && !this.loading
    }
  },
  watch: {
    // loading: function (val) {
    //   if (val) {
    //     this.expanded = false;
    //   }
    // }
  }
}
</script>

